import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useFeatureFlag = (flagKey: string) => {
  return useQuery({
    queryKey: ['feature-flag', flagKey],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('is_feature_enabled', { p_flag_key: flagKey });
      
      if (error) throw error;
      return data as boolean;
    },
    staleTime: 30 * 1000, // Cache for 30 seconds
    gcTime: 60 * 1000,
  });
};

export const useFeatureFlags = () => {
  return useQuery({
    queryKey: ['feature-flags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('*')
        .order('category', { ascending: true });
      
      if (error) throw error;
      return data;
    },
    staleTime: 30 * 1000,
  });
};
